import { render, staticRenderFns } from "./AddressBook.vue?vue&type=template&id=90ebf8bc&scoped=true&"
import script from "./AddressBook.vue?vue&type=script&lang=js&"
export * from "./AddressBook.vue?vue&type=script&lang=js&"
import style0 from "./AddressBook.vue?vue&type=style&index=0&id=90ebf8bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90ebf8bc",
  null
  
)

export default component.exports